/* global axios */
import ApiClient from '../ApiClient';

// M26.10 Part 13 — Executive Dashboard. Thin client for
// Nexceo::Reports::AiCoreCertificationReportService, exposed via
// AiCoreHealthController. No aggregation logic here.
class NexceoAiCoreHealthAPI extends ApiClient {
  constructor() {
    super('nexceo/ai_core_health', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  regenerate() {
    return axios.post(`${this.url}/regenerate`);
  }
}

export default new NexceoAiCoreHealthAPI();
